import React from 'react';
import { EfficiencyChartContainer } from '../charts';
import ChartTab from './ChartTab';

interface EfficiencyTabProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  syncGroup?: string;
  activeSubTab?: 'efficiency' | 'utilization';
  onActiveSubTabChange?: (tab: 'efficiency' | 'utilization') => void;
}

const EfficiencyTab: React.FC<EfficiencyTabProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  syncGroup,
  activeSubTab,
  onActiveSubTabChange
}) => {
  return (
    <ChartTab>
      <EfficiencyChartContainer 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        syncGroup={syncGroup}
        activeSubTab={activeSubTab}
        onActiveSubTabChange={onActiveSubTabChange}
      />
    </ChartTab>
  );
};

export default EfficiencyTab;
